<template>
  <div class="flex flex-col mt-2 md:mt-0 h-full overflow-y-auto">
    <!-- Desktop header -->
    <div v-if="!isMobile" class="flex-none w-full pe-2 ps-8 pt-4 pb-2 border-gray-100">
      <h2 class="text-2xl font-medium text-gray-800">קמפיין הודעות</h2>
      <p class="text-sm text-surface-500 mt-1">שליחת הודעת SMS יזומה — לכל הלקוחות, לקבוצה נבחרת או ללקוח יחיד.</p>
    </div>
    <div class="md:px-8 md:pt-4">
      <send-sms-tab />
    </div>
  </div>
</template>

<script lang="ts" setup>

import { onMounted } from 'vue';
import { useAdminStore } from '@app/stores';
import { AdminRouteNames } from '@app/router/route-names';
import SendSmsTab from './pages/communication/SendSmsTab.vue';
import { useResponsive } from '@app/composables/responsive';
import { trackEvent } from '@app/composables/posthog';

const { isMobile } = useResponsive();

const adminStore = useAdminStore();
const { setPage } = adminStore;

onMounted(() => {
  trackEvent('campaigns_viewed');
  setPage(AdminRouteNames.Campaigns);
});
</script>
